import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

const bathroomQuiz = [
  {
    title: "【你家的「浴室」，是黴菌的樂園嗎？】",
    subtitle: "磁磚縫",
    image: process.env.PUBLIC_URL + "/img/bathroom-quiz1.webp",
    points: [
      { x: 40, y: 28, correct: false }, // 紅點
      { x: 38, y: 60, correct: false }, // 紅點
      { x: 52, y: 55, correct: true },  // 藍點（正確）
    ],
    info: {
      luluImg: process.env.PUBLIC_URL + "/img/20.webp",
      title: "Lulu防霉小教室",
      content: [
        "🧽瓷磚縫不是安全地帶！黴菌超愛住在潮濕、縫隙多又難清的地方，而浴室瓷磚縫正好符合所有條件，根本是它們的五星級飯店！像是黑黴菌、青黴菌、念珠菌、葡萄黴菌，最常躲在：",
        "・磁磚與磁磚的交接縫",
        "・地面排水孔邊緣",
        "・浴缸與牆面間的防水矽膠條",
        "這些黴菌不只讓地面髒兮兮，還會產生孢子飄散，長期吸入可能引起：😷過敏、氣喘、皮膚癢、頭暈，",
        "✅三招搞定黴菌磁磚縫：",
        "1. 刷洗磁磚縫跟牆角，角落、膠條別放過！",
        "2. 洗完澡記得除濕，窗戶、排風扇一定要開",
        "3. 一週一次清潔，減少黴菌生長"
      ]
    }
  },
  {
    title: "【你家的「浴室」，是黴菌的樂園嗎？】",
    subtitle: "洗手台",
    image: process.env.PUBLIC_URL + "/img/bathroom-quiz2.webp",
    points: [
      { x: 33, y: 22, correct: false }, // 紅點
      { x: 65, y: 20, correct: false }, // 紅點
      { x: 40, y: 78, correct: true },  // 藍點（正確）
    ],
    info: {
      luluImg: process.env.PUBLIC_URL + "/img/20.webp",
      title: "Lulu防霉小教室",
      content: [
        "🧼洗手台不是你想的那麼無菌！",
        "每天洗手洗臉刷牙，但你有注意過洗手台邊緣、下方排水孔、甚至水龍頭底座嗎？",
        "這些地方水氣、泡沫、牙膏垢、肥皂殘渣堆積起來，是黴菌最愛躲的角落！",
        "像黑黴菌、青黴菌、念珠菌、葡萄黴菌，尤其最長就在：",
        "・洗手台與牆面間的矽膠條",
        "・排水孔與檯面交接縫",
        "・洗手台座與檯面交界的縫隙",
        "這些黴菌不只是髒，還會釋放肉眼看不到的孢子，導致：過敏反應、氣喘發作、皮膚搔癢",
        "✅三招遠離黴菌洗手台：",
        "1. 擦拭邊角，濕氣殘渣勤刮掰！",
        "2. 有泡沫不要等乾才擦，清潔就從『當下』開始！",
        "3. 發現排水孔積垢，一定要更換老化防水條"
      ]
    }
  },
  {
    title: "【你家的「浴室」，是黴菌的樂園嗎？】",
    subtitle: "排水孔",
    image: process.env.PUBLIC_URL + "/img/bathroom-quiz3.webp",
    points: [
      { x: 40, y: 20, correct: false }, // 紅點
      { x: 53, y: 22, correct: true },  // 藍點（正確）
      { x: 44, y: 80, correct: false }, // 紅點
    ],
    info: {
      luluImg: process.env.PUBLIC_URL + "/img/20.webp",
      title: "Lulu防霉小教室",
      content: [
        "排水孔是浴室潮濕、最常忽略的地帶，裡面卡著頭髮、泡沫、皮脂、肥皂垢，簡直是黴菌的營養午餐！像是黑黴菌、青黴菌、念珠菌、葡萄黴菌，最愛躲在：",
        "・排水蓋下方的縫縫、毛髮堵塞物",
        "・管道內壁積水區域",
        "・地板防夾對邊排水孔交界處",
        "黴菌不只是讓排水口看起來髒兮兮，還可能造成：",
        "1. 浴室發霉味+異味",
        "2. 黴菌孢子飄散，引致過敏、氣喘、皮膚不適",
        "3. 排水口阻塞，造成積水與滑倒危機！",
        "✅三招遠離黴菌排水口：",
        "1. 定期打開排水蓋，清除毛髮與堵物",
        "2. 定期用熱水+小蘇打+白醋沖洗，溫和除霉",
        "3. 加裝濾網／替換濾心，降低髒污堆積機會"
      ]
    }
  },
  {
    title: "【你家的「浴室」，是黴菌的樂園嗎？】",
    subtitle: "沐浴用品",
    image: process.env.PUBLIC_URL + "/img/bathroom-quiz4.webp",
    points: [
      { x: 38, y: 18, correct: false }, // 紅點
      { x: 44, y: 44, correct: true },  // 藍點（正確）
      { x: 62, y: 82, correct: false }, // 紅點
    ],
    info: {
      luluImg: process.env.PUBLIC_URL + "/img/20.webp",
      title: "Lulu防霉小教室",
      content: [
        "🧴瓶瓶罐罐不是永遠乾淨！黴菌早就在瓶底偷偷定居啦～你是不是用完洗髮精就順手往地上一放？還濕搭搭地堆在浴室角落？？小心！這些瓶罐是黴菌最愛的『養成皿』！！",
        "像青黴菌、黑黴菌還有酵母黴類（如念珠菌），都喜歡潮濕、不流通、殘留肥皂泡的地方～瓶底積水、瓶口堆積殘液，久未清洗的情況，超容易發霉、變滑、甚至發臭！",
        "而這些看似『只是瓶子外觀髒』的問題，其實可能：",
        "😖 黴菌隨角石沾到皮膚，導致毛囊炎或濕疹",
        "😷 透過吸入孢子引發過敏反應或呼吸道不適",
        "🦠 免疫較差者甚至可能出現局部黴菌感染（像是念珠菌感染）！",
        "✅瓶瓶罐罐遠離黴菌的三步驟：",
        "1. 用完後馬上沖一點水，瓶口刷乾泡沫堆積～🧽",
        "2. 瓶罐避免堆、離排水地，避免瓶底積水！建議放在瀝水架上",
        "3. 定期擦拭、刷洗瓶底，保持乾燥不積水"
      ]
    }
  },
  {
    title: "【你家的「浴室」，是黴菌的樂園嗎？】",
    subtitle: "牙刷",
    image: process.env.PUBLIC_URL + "/img/bathroom-quiz5.webp",
    points: [
      { x: 38, y: 80, correct: false }, // 紅點
      { x: 50, y: 35, correct: true },  // 藍點（正確）
      { x: 68, y: 20, correct: false }, // 紅點
    ],
    info: {
      luluImg: process.env.PUBLIC_URL + "/img/20.webp",
      title: "Lulu防霉小教室",
      content: [
        "🪥牙刷不是放著就沒事！黴菌早就在刷毛上開趴啦～你是不是每天刷完牙就把牙刷往杯子一插？還放在潮濕的浴室角落？？小心牙刷變黴菌樂園，越刷越髒！",
        "像黑黴菌、青黴菌還有毛黴菌，都超愛濕濕熱熱的刷毛環境～尤其牙刷長時間潮濕、不通風、沒曬乾，根本是它們的天堂！",
        "刷毛一旦發霉，不只變色、發臭、軟爛塌，還可能釋放黴菌孢子，進入口腔、鼻腔，甚至造成：",
        "😖 牙齦炎、口腔潰瘍",
        "😷 呼吸道過敏、打噴嚏咳嗽不停",
        "🦠 免疫力低下者還可能引發黴菌感染，如黴菌性鼻竇炎或肺炎！",
        "✅讓牙刷保持潔淨的三步驟：",
        "1. 刷完牙後徹底沖洗，甩乾水分，豎立放置",
        "2. 牙刷架遠離馬桶，避免細菌飛濺",
        "3. 定期更換牙刷（3個月一換），不要等到刷毛變形才換"
      ]
    }
  }
];

export default function Bathroom() {
  const [quizIdx, setQuizIdx] = useState(0);
  const [showInfo, setShowInfo] = useState(false);
  const [wrongClick, setWrongClick] = useState(false);
  const [done, setDone] = useState(false);
  const quiz = bathroomQuiz[quizIdx];
  const navigate = useNavigate();

  function handlePointClick(point) {
    if (point.correct) {
      setShowInfo(true);
    } else {
      setWrongClick(true);
      setTimeout(() => setWrongClick(false), 600);
    }
  }

  function handleNext() {
    if (quizIdx < bathroomQuiz.length - 1) {
      setQuizIdx(quizIdx + 1);
      setShowInfo(false);
      setWrongClick(false);
    } else {
      setDone(true);
    }
  }

  if (done) {
    return (
      <div className="bathroom-quiz-container" style={{ background: '#99C221', minHeight: '100vh', padding: 0 }}>
        <div style={{ maxWidth: 900, margin: '0 auto', background: 'none', borderRadius: 12, padding: 0, textAlign: 'center', minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div style={{ fontSize: '3rem', fontWeight: 700, margin: '48px 0 0 0', letterSpacing: 2 }}>太棒了！浴室篇結束</div>
          <div style={{ display: 'flex', justifyContent: 'center', margin: '48px 0 32px 0' }}>
            <img src={process.env.PUBLIC_URL + '/img/finish.webp'} alt="Lulu thumbs up" style={{ width: 220, height: 220, objectFit: 'contain', background: '#444', borderRadius: 16 }} />
          </div>
          <div style={{ fontSize: '2.5rem', fontWeight: 500, margin: '0 0 18px 0', letterSpacing: 1 }}>恭喜你找到浴室中黴菌喜歡生長的地方！</div>
          <div style={{ fontSize: '2.5rem', fontWeight: 500, margin: '0 0 36px 0', letterSpacing: 1 }}>快去檢查看看你的浴室中有沒有這些黴菌吧！</div>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginBottom: 48 }}>
            <button
              className="main-btn"
              style={{ background: 'rgba(154, 71, 61, 0.97)', color: 'white', border: 'none', padding: '16px 32px', borderRadius: 8, fontSize: '1.5rem', fontWeight: 700, cursor: 'pointer' }}
              onClick={() => navigate('/diagnosis')}
            >
              去檢查
            </button>
            <button 
              onClick={() => navigate('/main')} 
              style={{ background: 'rgba(154, 71, 61, 0.97)', color: 'white', border: 'none', padding: '16px 32px', borderRadius: 8, fontSize: '1.5rem', fontWeight: 700, cursor: 'pointer' }}
            >
              回首頁
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bathroom-quiz-container" style={{ background: '#99C221', minHeight: '100vh', padding: 20 }}>
      <div style={{ display: 'flex', gap: 24, alignItems: 'center', marginBottom: 16 }}>
        <Link to="/main" style={{ color: '#2b9aff', fontWeight: 700, fontSize: 20, textDecoration: 'none' }}>無黴行動</Link>
        <Link to="/survey" style={{ color: '#2b9aff', fontWeight: 700, fontSize: 18, textDecoration: 'underline' }}>填寫問卷</Link>
      </div>
      <div style={{ maxWidth: 900, margin: '0 auto', background: '#fff', borderRadius: 12, boxShadow: '0 2px 12px #0001', padding: 24 }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
          <div>
            <div style={{ fontSize: '2rem', fontWeight: 700, marginBottom: 8 }}>{quiz.title}</div>
            <div style={{ fontSize: '1.4rem', fontWeight: 500, marginBottom: 12 }}>{quiz.subtitle}</div>
            <div style={{ color: '#444', fontSize: '1rem', marginBottom: 8 }}>《點點看，黴菌在哪裡？》</div>
          </div>
          <img src={process.env.PUBLIC_URL + '/img/03.webp'} alt="Lulu" style={{ width: 120, height: 120, borderRadius: 14, background: '#eee' }} />
        </div>
        <div style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
          <img src={quiz.image} alt="quiz content" style={{ width: 340, height: 260, borderRadius: 8, objectFit: 'cover' }} />
          {quiz.points.map((point, index) => (
            <div
              key={index}
              onClick={() => handlePointClick(point)}
              style={{
                position: 'absolute',
                top: `${point.y}%`,
                left: `${point.x}%`,
                width: 28,
                height: 28,
                borderRadius: '50%',
                background: point.correct ? 'rgba(255, 0, 0, 0.7)' : 'rgba(255, 0, 0, 0.7)',
                cursor: 'pointer',
                border: '3px solid white',
                boxShadow: '0 0 10px rgba(0,0,0,0.5)',
                transform: 'translate(-50%, -50%)',
                animation: !point.correct && wrongClick ? 'flash 0.6s' : 'none'
              }}
              title={point.correct ? '正確答案' : '不是這裡'}
            />
          ))}
        </div>
        {showInfo && (
          <div style={{
            background: '#f8f8e8',
            borderRadius: 10,
            margin: '32px 0 0 0',
            padding: '24px 32px',
            boxShadow: '0 1px 6px #0001',
            display: 'flex',
            alignItems: 'flex-start',
            gap: 24,
            border: '2px solid #b0e0e6'
          }}>
            <img src={quiz.info.luluImg} alt="Lulu" style={{ width: 60, height: 60, borderRadius: 10, marginRight: 16 }} />
            <div>
              <div style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: 8 }}>{quiz.info.title}</div>
              {quiz.info.content.map((line, i) => (
                <div key={i} style={{ fontSize: '1.08rem', marginBottom: 4 }}>{line}</div>
              ))}
            </div>
          </div>
        )}
        {showInfo && (
          <div style={{ textAlign: 'right', marginTop: 24 }}>
            <button onClick={handleNext} style={{
              background: '#4caf50',
              color: '#fff',
              fontSize: '1.1rem',
              fontWeight: 600,
              padding: '10px 32px',
              border: 'none',
              borderRadius: 8,
              boxShadow: '0 2px 8px #0001',
              cursor: 'pointer',
              marginRight: 8
            }}>
              {quizIdx < bathroomQuiz.length - 1 ? '下一題 →' : '完成'}
            </button>
          </div>
        )}
      </div>
    </div>);
}
